// @flow

import React from 'react';
import { toArray } from 'react-emoji-render';


import { translate } from '../../../base/i18n';
import { Linkify } from '../../../base/react';
import { GIF_PREFIX } from '../../../gifs/constants';
import { isGifMessage } from '../../../gifs/function.any';
import { MESSAGE_TYPE_LOCAL } from '../../constants';
import { getMessageText } from '../../functions';
import AbstractChatMessage, {
    type Props
} from '../AbstractChatMessage';
import PrivateMessageButton from '../PrivateMessageButton';

import GifMessage from './GifMessage';


/**
 * Renders a single chat message.
 */
class ChatMessage extends AbstractChatMessage<Props> {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { message, t } = this.props;
        const processedMessage = [];

        // const getOBJECT = isStringJson(message.message);
        // const getName = typeof getOBJECT === 'object' ? getFilename(getOBJECT.filePath) : null;

        // file details
        // const obj = {
        //     destination: "/Users/vempmac15/Desktop/node-js-express-download-file/resources/static/assets/uploads/",
        //     encoding: "7bit",
        //     fieldname: "file",
        //     filePath: "http://localhost:8080/files/stray-game-review-ps5-pc-ps4.jpeg",
        //     filename: "stray-game-review-ps5-pc-ps4.jpeg",
        //     mimetype: "image/jpeg",
        //     originalname: "stray-game-review-ps5-pc-ps4.jpeg",
        //     path: "/Users/vempmac15/Desktop/node-js-express-download-file/resources/static/assets/uploads/stray-game-review-ps5-pc-ps4.jpeg",
        //     size: 61063
        //     }
        // if (typeof getOBJECT === 'object' && (/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%.+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g).test(getOBJECT.filePath)
        // && FILE_NAME.some(it => getName.includes(it))) {
        //     return (<><MessageBox
        //         data = {{
        //             uri: message.message
        //         }}
        //         key = { message.timestamp }
        //         onClick = { e => window.open(getOBJECT.filePath, '_blank') }
        //         position = { message.messageType === MESSAGE_TYPE_LOCAL ? 'right' : 'left' }
        //         text = { 'Attachment ' }
        //         title = { message.displayName }
        //         type = { 'file' } />
        //     { this.props.showTimestamp && this._renderTimestamp() }
        //     </>);


        // }

        const txt = this._getMessageText();

        // Tokenize the text in order to avoid emoji substitution for URLs.
        const tokens = txt.split(' ');

        // Content is an array of text and emoji components
        const content = [];
        const text = getMessageText(message);

        if (isGifMessage(text)) {
            const url = text.substring(GIF_PREFIX.length, text.length - 1);

            content.push(<GifMessage
                key = { url }
                url = { url } />);
        } else {
            for (const token of tokens) {
                if (token.includes('://')) {
                    // It contains a link, bypass the emojification.
                    content.push(token);
                } else {
                    content.push(...toArray(token, { className: 'smiley' }));
                }

                content.push(' ');
            }
        }

        content.forEach(i => {
            if (typeof i === 'string') {
                processedMessage.push(<Linkify key = { i }>{ i }</Linkify>);
            } else {
                processedMessage.push(i);
            }
        });

        return (
            <div className = 'chatmessage-wrapper'>
                <div className = { `chatmessage ${message.privateMessage ? 'privatemessage' : ''}` }>
                    <div className = 'replywrapper'>
                        <div className = 'messagecontent'>
                            { this.props.showDisplayName && this._renderDisplayName() }
                            <div className = 'usermessage'>
                                <span className = 'sr-only'>
                                    { this.props.message.displayName === this.props.message.recipient
                                        ? t('chat.messageAccessibleTitleMe')
                                        : t('chat.messageAccessibleTitle',
                                        { user: this.props.message.displayName }) }
                                </span>
                                { processedMessage }
                            </div>
                            { message.privateMessage && this._renderPrivateNotice() }
                        </div>
                        { message.privateMessage && message.messageType !== MESSAGE_TYPE_LOCAL
                            && (
                                <div className = 'messageactions'>
                                    <PrivateMessageButton
                                        participantID = { message.id }
                                        reply = { true }
                                        showLabel = { false } />
                                </div>
                            ) }
                    </div>
                </div>
                { this.props.showTimestamp && this._renderTimestamp() }
            </div>
        );
    }

    _getFormattedTimestamp: () => string;

    _getMessageText: () => string;

    _getPrivateNoticeMessage: () => string;

    /**
     * Renders the display name of the sender.
     *
     * @returns {React$Element<*>}
     */
    _renderDisplayName() {
        return (
            <div className = 'display-name'>
                { this.props.message.displayName }
            </div>
        );
    }

    /**
     * Renders the message privacy notice.
     *
     * @returns {React$Element<*>}
     */
    _renderPrivateNotice() {
        return (
            <div className = 'privatemessagenotice'>
                { this._getPrivateNoticeMessage() }
            </div>
        );
    }

    /**
     * Renders the time at which the message was sent.
     *
     * @returns {React$Element<*>}
     */
    _renderTimestamp() {
        return (
            <div className = 'timestamp'>
                { this._getFormattedTimestamp() }
            </div>
        );
    }
}

export default translate(ChatMessage);
